import React from "react";
import { Navigate } from "react-router-dom";

import useFlag from "@/hooks/useFlag";
import FeatureFlags from "@/utils/featureFlags";

type WithFeatureFlagRedirectOptions = {
  redirectPath?: string;
};

export const withFeatureFlagRedirect =
  (flag: FeatureFlags, options?: WithFeatureFlagRedirectOptions) =>
  <P extends object>(Wrapped: React.ComponentType<P>): React.FC<P> => {
    const redirectPath = options?.redirectPath ?? "/";

    const GuardedComponent: React.FC<P> = (props) => {
      const enabled = useFlag(flag);

      if (!enabled) {
        return <Navigate to={redirectPath} replace />;
      }

      return <Wrapped {...props} />;
    };

    const wrappedName = Wrapped.displayName ?? Wrapped.name ?? "Component";
    GuardedComponent.displayName = `withFeatureFlagRedirect(${wrappedName})`;

    return GuardedComponent;
  };
